import { User } from 'modules/domain/user/types'

import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { Card } from 'views/components/Card/Card'
import { UserLinkWithIcons } from 'views/components/UserLinkWithIcons/UserLinkWithIcons'
import APhone from 'views/ui/Phone/APhone'

const UserInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 4px;
`

export const CompanyUsers: FC<{ users: User[] }> = ({ users }) => {
  const { t } = useTranslation()
  return (
    <Card.GapableContent>
      <Card.Title>{t('user:usersMetaTitle')}</Card.Title>
      {users.map((user) => (
        <UserInfoWrapper key={user.id}>
          <UserLinkWithIcons user={user} />
          <div>{t(`user:profile_type.${user.profile?.profile_type}`)}</div>
          <APhone phone={user.phone} />
        </UserInfoWrapper>
      ))}
    </Card.GapableContent>
  )
}
